import { type PropsWithChildren, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";

import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  isClosing: boolean;
  isOpen: boolean;
  onClose: VoidFunction;
};

export function SidebarModalRoot({
  children,
  isClosing,
  isOpen,
  onClose,
}: PropsWithChildren<Props>) {
  const el = useMemo(() => document.createElement("div"), []);
  const { theme } = useTheme();

  useEffect(() => {
    const modalRoot = document.getElementById("sidebar-modal-root");

    if (modalRoot) {
      modalRoot.appendChild(el);
    }

    return () => {
      modalRoot && modalRoot.removeChild(el);
    };
  }, [el]);

  return createPortal(
    <div
      className={cnTwMerge("sidebar-modal-container text-text/primary", theme, {
        hidden: !isOpen,
        "sidebar-closed": isClosing,
        "sidebar-open": isOpen && !isClosing,
      })}
      onClick={onClose}
    >
      {children}
    </div>,

    el,
  );
}
